import t from 'tcomb';

// given the successHandler and the errorHandler returns a node like callback:
// `err` as first argument, `result` as second argument
export default function createCallback(successHandler: t.Function, errorHandler: t.Function): t.Function {
  return (err, result) => {
    if (err) {
      errorHandler(err);
    }
    else {
      successHandler(result);
    }
  };
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/createCallback.js
 **/